import env from "react-dotenv";
import { getCookie } from "../util/generic";

export const getHeaders = async () => {

    const token = getCookie('XSRF-TOKEN')

    const headers: HeadersInit = {
        'Content-Type':'application/json',
        'Accept':'application/json',
        "X-XSRF-TOKEN": token
    };

    return headers;
}

export const post = async (destination:string, body:object, method:string = 'POST') => {
    const headers = await getHeaders();
    

    const result = await fetch(`${env.API_URL}${destination}`, {
        method: method,
        headers: headers,
        body: JSON.stringify(body),
        credentials: 'include'
    });
    
    if(result.ok) {
        return await result.json();
    }
    throw { error: result.status };
}

export const get = async (destination:string) => {
    const headers = await getHeaders();

    const result = await fetch(`${env.API_URL}${destination}`, {
        method: 'GET',
        headers: headers,
        credentials: 'include',
    });

    if(result.ok) {
        return await result.json();
    }
    throw { error: result.status };
}

export const remove = async (destination:string) => {
    const headers = await getHeaders()

    const result = await fetch(`${env.API_URL}${destination}`, {
        method: 'DELETE',
        headers: headers,
        credentials: 'include'
    });

    if(result.ok) {
        return await result.json();
    }
    throw { error: result.status };
}

export const getXSRFToken = async() => {
    const result = await fetch(`${env.API_URL}/sanctum/csrf-cookie`, {
        method: 'GET',
        credentials: 'include'
    });

    if(!result.ok) {
        console.log(result.statusText)
    }

    return
}